// Admin panel (/admin): own login, then four tabs — media management, category
// management, uploads into any category, statistics. Optimized for efficiency,
// not ceremony: dense grids, inline editing, explicit confirms for destruction.
import React, { useState } from 'react';
import { api } from '../api.js';
import { Link } from '../router.jsx';
import MediaManager from '../admin/media-manager.jsx';
import CategoryEditor from '../admin/category-editor.jsx';
import Stats from '../admin/stats.jsx';
import AdminUpload from '../admin/admin-upload.jsx';
import { toast } from '../components/toast.jsx';

function AdminLogin({ onLoggedIn }) {
	const [user, setUser] = useState('admin');
	const [password, setPassword] = useState('');
	const [busy, setBusy] = useState(false);

	const submit = async (e) => {
		e.preventDefault();
		if (busy) return;
		setBusy(true);
		try {
			await api.adminLogin(user, password);
			onLoggedIn();
		} catch (err) {
			toast(err.status === 429 ? 'Zu viele Versuche – bitte kurz warten.' : 'Anmeldung fehlgeschlagen.', 'error');
		} finally {
			setBusy(false);
		}
	};

	return (
		<div className='adminlogin'>
			<h1 className='adminlogin__title'>Admin</h1>
			<form className='adminlogin__form' onSubmit={submit}>
				<input className='input' type='text' placeholder='Benutzer' autoComplete='username' value={user} onChange={(e) => setUser(e.target.value)} />
				<input
					className='input'
					type='password'
					placeholder='Passwort'
					autoComplete='current-password'
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					autoFocus
				/>
				<button type='submit' className='btn btn--primary' disabled={busy || !password}>
					Anmelden
				</button>
			</form>
		</div>
	);
}

const TABS = [
	{ id: 'media', label: 'Medien' },
	{ id: 'categories', label: 'Kategorien' },
	{ id: 'upload', label: 'Upload' },
	{ id: 'stats', label: 'Statistik' },
];

export default function Admin({ auth, onAuthChange }) {
	const [tab, setTab] = useState('media');

	if (!auth.admin) {
		return <AdminLogin onLoggedIn={() => onAuthChange({ ...auth, guest: true, admin: true })} />;
	}

	const logout = async () => {
		try {
			await api.adminLogout();
		} catch {
			/* cookie is gone either way */
		}
		onAuthChange({ ...auth, admin: false });
	};

	return (
		<div className='admin'>
			<div className='admin__head'>
				<h1 className='admin__title'>Verwaltung</h1>
				<div className='admin__headactions'>
					<Link to='/' className='btn btn--ghost admin__smallbtn'>
						Zur Galerie
					</Link>
					<button type='button' className='btn btn--ghost admin__smallbtn' onClick={logout}>
						Abmelden
					</button>
				</div>
			</div>
			<nav className='admin__tabs' aria-label='Bereiche'>
				{TABS.map((t) => (
					<button
						key={t.id}
						type='button'
						className={`admin__tab ${tab === t.id ? 'admin__tab--active' : ''}`}
						aria-current={tab === t.id ? 'page' : undefined}
						onClick={() => setTab(t.id)}>
						{t.label}
					</button>
				))}
			</nav>
			{tab === 'media' && <MediaManager />}
			{tab === 'categories' && <CategoryEditor />}
			{tab === 'upload' && <AdminUpload />}
			{tab === 'stats' && <Stats />}
		</div>
	);
}
